import { IPagination } from 'app/types/common';

export interface IPaymentTagsState {
  readonly paymentTagsById?: any;
  readonly paymentTagIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPaymentTagLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPaymentTag?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentTagIds?: string[];
  readonly currentPaymentTagId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentTagsSelector
  extends IPaymentTagsState {
  readonly currentPaymentTag?: any;
  readonly currentFormPaymentTag?: any;
  readonly paymentTagsFilteredByOrganisationInSelectFormat?: any;
  readonly paymentTagsByTagAndIdInSelectFormat?: any;
  readonly paymentTagsByIdInSelectFormat?: any;
  readonly paymentTagsFilteredByCompetitionInSelectFormat?: any;
  readonly paymentTagsFilteredByIdInSelectFormat?: any;
}

export enum PaymentTagsActionTypes {
  GET_ALL_PAYMENT_TAGS_REQUESTED = 'redux-app/payment-tags/GET_ALL_PAYMENT_TAGS_REQUESTED',
  GET_ALL_PAYMENT_TAGS_PENDING = 'redux-app/payment-tags/GET_ALL_PAYMENT_TAGS_PENDING',
  GET_ALL_PAYMENT_TAGS_SUCCESS = 'redux-app/payment-tags/GET_ALL_PAYMENT_TAGS_SUCCESS',
  GET_ALL_PAYMENT_TAGS_FAIL = 'redux-app/payment-tags/GET_ALL_PAYMENT_TAGS_FAIL',
  GET_PAYMENT_TAG_REQUESTED = 'redux-app/payment-tags/GET_PAYMENT_TAG_REQUESTED',
  GET_PAYMENT_TAG_PENDING = 'redux-app/payment-tags/GET_PAYMENT_TAG_PENDING',
  GET_PAYMENT_TAG_SUCCESS = 'redux-app/payment-tags/GET_PAYMENT_TAG_SUCCESS',
  GET_PAYMENT_TAG_FAIL = 'redux-app/payment-tags/GET_PAYMENT_TAG_FAIL',
  UPDATE_PAYMENT_TAG_REQUESTED = 'redux-app/payment-tags/UPDATE_PAYMENT_TAG_REQUESTED',
  UPDATE_PAYMENT_TAG_PENDING = 'redux-app/payment-tags/UPDATE_PAYMENT_TAG_PENDING',
  UPDATE_PAYMENT_TAG_SUCCESS = 'redux-app/payment-tags/UPDATE_PAYMENT_TAG_SUCCESS',
  UPDATE_PAYMENT_TAG_FAIL = 'redux-app/payment-tags/UPDATE_PAYMENT_TAG_FAIL',
  CREATE_PAYMENT_TAG_REQUESTED = 'redux-app/payment-tags/CREATE_PAYMENT_TAG_REQUESTED',
  CREATE_PAYMENT_TAG_PENDING = 'redux-app/payment-tags/CREATE_PAYMENT_TAG_PENDING',
  CREATE_PAYMENT_TAG_SUCCESS = 'redux-app/payment-tags/CREATE_PAYMENT_TAG_SUCCESS',
  CREATE_PAYMENT_TAG_FAIL = 'redux-app/payment-tags/CREATE_PAYMENT_TAG_FAIL',
  DELETE_PAYMENT_TAG_REQUESTED = 'redux-app/payment-tags/DELETE_PAYMENT_TAG_REQUESTED',
  DELETE_PAYMENT_TAG_PENDING = 'redux-app/payment-tags/DELETE_PAYMENT_TAG_PENDING',
  DELETE_PAYMENT_TAG_SUCCESS = 'redux-app/payment-tags/DELETE_PAYMENT_TAG_SUCCESS',
  DELETE_PAYMENT_TAG_FAIL = 'redux-app/payment-tags/DELETE_PAYMENT_TAG_FAIL',
  SELECT_PAYMENT_TAG_REQUESTED = 'redux-app/payment-tags/SELECT_PAYMENT_TAG_REQUESTED',
}

export default null;
